var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menubar"},[_c('b-button',{attrs:{"disabled":_vm.disabled,"variant":"warning"},on:{"click":function($event){return _vm.handleClick('refresh')}}},[_vm._v(" Refresh ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }